import { render } from "./profil-page.vue?vue&type=template&id=2310c1c0&scoped=true"
import script from "./profil-page.vue?vue&type=script&lang=js"
export * from "./profil-page.vue?vue&type=script&lang=js"

import "./profil-page.scss?vue&type=style&index=0&id=2310c1c0&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2310c1c0"]])

export default __exports__